import {takeEvery, put, call, takeLatest} from "redux-saga/effects"

// Login Redux States
import {
    GEO_REVERSE_COORDINATES,
    GEO_DISTANCE_COORDINATES,
    SEARCH_ADDRESS,
} from "./actionTypes"

import {
    reverseCoordinatesSuccess,
    distanceCoordinatesSuccess,
    searchAddressSuccess,
    apiLocationError
} from "./actions"

import {
    getReverseCoordinates,
    getDistanceCoordinates,
    getSearchAddress,
} from "../../../helpers/location_helper"

function* distanceCoordinates({payload: {params}}) {
    try {

        const response = yield call(getDistanceCoordinates, params)
        const {geocoded_waypoints, routes} = response;
        const {bounds, legs} = routes[0];
        const {duration, distance} = legs[0];
        yield put(distanceCoordinatesSuccess({duration, distance}))
        

    } catch (error) {//distance_type
        yield put(apiLocationError(error))
    }
}

function* reverseCoordinates({payload: {params}}) {
    try {

        const {results} = yield call(getReverseCoordinates, params)
        const {formatted_address, geometry} = results;
        const {location} = geometry;

        yield put(reverseCoordinatesSuccess({
            address: formatted_address,
            coordinates: location
        }))


    } catch (error) {
        yield put(apiLocationError(error))
    }
}

function* searchAddress({payload: {params}}) {
    try {

        const {results} = yield call(getSearchAddress, params)

        const {formatted_address, geometry} = results[0];
        const {location} = geometry;

        yield put(searchAddressSuccess({
            address: formatted_address,
            coordinates: location
        }))

    } catch (error) {
        yield put(apiLocationError(error))
    }
}


function* locationSaga() {
    yield takeEvery(GEO_REVERSE_COORDINATES, reverseCoordinates)
    yield takeEvery(GEO_DISTANCE_COORDINATES, distanceCoordinates)
    yield takeEvery(SEARCH_ADDRESS, searchAddress)
}

export default locationSaga
